module.exports = __webpack_public_path__ + "img/Frente-5-00 off.57e64aac.png";